module.exports = __webpack_public_path__ + "img/small.564ea961.jpg";